import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const IdleTimerWithPrompt = ({ idleLink = "/", timeout = 40 * 60 * 1000, promptBeforeIdle = 3 * 60 * 1000 }) => {
  const [remaining, setRemaining] = useState(timeout);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
 
  const onIdle = () => {
    console.debug("Idle");
    setOpen(false);
    navigate(idleLink, { state: {} });
    //window.location.href = idleUrl;  
  };

  const onActive = () => {
    console.debug("Active");
    setOpen(false);
  };

  const onPrompt = () => {
    console.debug("Are you still there?");
    setOpen(true);
  };

  const handleStillHere = () => {
    activate();
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime()));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.ceil(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes} minute${minutes !== 1 ? 's' : ''} and ${seconds} second${seconds !== 1 ? 's' : ''}`;
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleStillHere}
        aria-labelledby="idle-modal-title"
        aria-describedby="idle-modal-description"
      >
        <Box 
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 300,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            textAlign: 'center'
          }}
        >
          <Typography id="idle-modal-title" variant="h6" component="h2">
            Are you still here?
          </Typography>
          <Typography id="idle-modal-description" sx={{ mt: 2 }}>
            Logging out in {formatTime(remaining)}
          </Typography>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleStillHere}
            sx={{ mt: 3 }}
          >
            I'm still here
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default IdleTimerWithPrompt;